import { FC } from 'react';

import CountdownTimer from 'components/CountdownTimer/CountdownTimer';

import styles from './AuthThankYouMessage.module.scss';

interface AuthThankYouMessageProps {
  link: string;
  initialCountdown: number;
  newJobseeker?: boolean;
}

const AuthThankYouMessage: FC<AuthThankYouMessageProps> = ({
  link,
  initialCountdown,
  newJobseeker = false
}) => {
  const handleRedirect = () => {
    window.location.href = link;
  };

  const oldUserMessage = (
    <div className={styles.redirectContainer}>
      <p>
        Redirecting you to our career platform in{' '}
        <span className={styles.seconds}>
          <CountdownTimer
            initialTime={initialCountdown}
            isActive={true}
            onComplete={handleRedirect}
            renderContent={(countdown) => `${countdown}`}
          />
        </span>{' '}
        seconds. Apply, connect, and start your journey in our job marketplace!
        <br />
        If the redirection does not happen automatically,{' '}
        <a href={link} target="_blank" rel="noopener noreferrer">
          click here
        </a>
        .
      </p>
    </div>
  );

  const newUserMessage = (
    <div className={styles.redirectContainer}>
      <p>
        Thank you for registration. A temporary password has been sent to your
        email. Please follow the instructions to activate your account. Apply,
        connect, and start your journey in our job{' '}
        <a href={link} target="_blank" rel="noopener noreferrer">
          marketplace!
        </a>
      </p>
    </div>
  );

  return newJobseeker ? newUserMessage : oldUserMessage;
};

export default AuthThankYouMessage;
